import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { UserStorage } from "./UserContext";
import ProtectedRoute from "./protectedRoutes/ProtectedRoute";
import "bootstrap/dist/css/bootstrap.min.css";

import Footer from "./Components/Footer";
import Header from "./Components/Header";

import Home from "./Pages/Home/Home";
import Sobre from "./Pages/sobre/sobre";
import Equipe from "./Pages/equipe/equipe";
import Contato from "./Pages/contato/contato";
import Login from "./Pages/login/Login";
import WebPush from "./Pages/webpush/WebPush";
import Dashboards from "./Pages/dashboards/Dashboards";
import SitemapConcorrentes from "./Pages/dashboards/7SitemapConcorrentes";
import DahsPortais from "./Pages/dashboards/1DashPortais";
import IndicadoresBlog from "./Pages/dashboards/2IndicadoresBlog";
import IndicadoresSeo from "./Pages/dashboards/3IndicadoresSeo";
import DashCms from "./Pages/dashboards/4DashCms";
import ReportMensalPortais from "./Pages/dashboards/5ReportMensalPortais";
import ReportMensalSeo from "./Pages/dashboards/6ReportMensalSeo";

import LinksQuebrados from "./Pages/dashboards/8LinksQuebrados";
// import Sherlock from "./Pages/dashboards/9Sherlock";
import Inmetro from "./Pages/dashboards/910Inmetro";
import Galvao from "./Pages/dashboards/911Galvao";
import VitrineMensuracao from "./Pages/dashboards/912VitrineMensuracao";
import Menusca from "./Pages/dashboards/913Menusca";
import BoltSnt from "./Pages/dashboards/914BoltSnt";
import PipefyOpec from "./Pages/dashboards/915PipefyOpec";
import Pipefy from "./Pages/dashboards/916Pipefy";
import VitrineBasesManuais from "./Pages/dashboards/917VitrineBasesManuais";
import Componentes from "./Pages/dashboards/918Componentes";
import Onboarding from "./Pages/dashboards/919Onboarding";
import OfertaContextual from "./Pages/ofertaContextual/OfertaContextual";
import OfertaContextualRegistros from "./Pages/ofertaContextual/OfertaContextualRegistros";
import LoginChangePassword from './Components/ChangePasswordDialog/ChangePasswordDialog'

import Sherlock from "./Pages/Sherlock";

import "./App.css";
import Menu from "./Components/Menu";
import VitrineTelasComprovantes from "./Pages/vitrine/VitrineTelasComprovantes";
import WebPushRegister from "./Pages/webpush/WebPushRegister";
import WebPushExclusion from "./Pages/webpush/WebPushExclusion";
import WebPushAgendamentos from "./Pages/webpush/WebPushAgendamentos";
import WebPushAgendamentos2 from "./Pages/webpush/WebPushAgendamentos2";
import AdminMenu from "./Pages/admin/admin";
import PsicologiaInfantil from "./Pages/psicologiaInfantil/psicologiaInfantil";
import Pediatra from "./Pages/pediatra/pediatra";
import Nutricionista from "./Pages/nutricionista/nutricionista";
import Psicopedagogia from "./Pages/psicopedagogia/psicopedagogia";
import Fisioterapia from "./Pages/fisioterapia/fisioterapia";
import TranstornosAnsiedadeInfantil from "./Pages/transtornosansiedadeinfantil/transtornosansiedadeinfantil";
import Tdah from "./Pages/tdah/tdah";
import Avaliacaoneuropsicologica from "./Pages/avaliacaoneuropsicologica/avaliacaoneuropsicologica";

const App = () => {
  const [passwordDialog, setPasswordDialog] = React.useState(false)
  function handleCloseDialog() {
    setPasswordDialog(false)
  }
  return (
    <BrowserRouter>
      <UserStorage>
        <div className="container-main">
          <div className="container-routes">
            
            <Routes>
              <Route
                path="/vitrine-telas-comprovante"
                element={
                  <ProtectedRoute to={"/login"}>
                    <VitrineTelasComprovantes />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/oferta-contextual"
                element={
                  <ProtectedRoute to={"/login"}>
                    <OfertaContextual />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/oferta-contextual-registros"
                element={
                  <ProtectedRoute to={"/login"}>
                    <OfertaContextualRegistros />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/web-push"
                element={
                  <ProtectedRoute to={"/login"}>
                    <WebPush />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboards"
                element={
                  <ProtectedRoute to={"/login"}>
                    <Dashboards />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/dashboards/dash-portais"
                element={
                  <ProtectedRoute to={"/login"}>
                    <DahsPortais />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboards/indicadores-blog"
                element={
                  <ProtectedRoute to={"/login"}>
                    <IndicadoresBlog />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboards/indicadores-seo"
                element={
                  <ProtectedRoute to={"/login"}>
                    <IndicadoresSeo />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboards/dash-cms"
                element={
                  <ProtectedRoute to={"/login"}>
                    <DashCms />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboards/report-mensal-portais"
                element={
                  <ProtectedRoute to={"/login"}>
                    <ReportMensalPortais />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboards/report-mensal-seo"
                element={
                  <ProtectedRoute to={"/login"}>
                    <ReportMensalSeo />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboards/sitemap-concorrentes"
                element={
                  <ProtectedRoute to={"/login"}>
                    <SitemapConcorrentes />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboards/links-quebrados"
                element={
                  <ProtectedRoute to={"/login"}>
                    <LinksQuebrados />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/sherlock"
                element={
                  <ProtectedRoute to={"/login"}>
                    <Sherlock />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboards/inmetro"
                element={
                  <ProtectedRoute to={"/login"}>
                    <Inmetro />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboards/galvao-bueno"
                element={
                  <ProtectedRoute to={"/login"}>
                    <Galvao />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboards/vitrine-mensuracao"
                element={
                  <ProtectedRoute to={"/login"}>
                    <VitrineMensuracao />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboards/menusca"
                element={
                  <ProtectedRoute to={"/login"}>
                    <Menusca />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboards/bolt-snt"
                element={
                  <ProtectedRoute to={"/login"}>
                    <BoltSnt />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboards/pipefy-opec"
                element={
                  <ProtectedRoute to={"/login"}>
                    <PipefyOpec />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboards/pipefy-cms"
                element={
                  <ProtectedRoute to={"/login"}>
                    <Pipefy />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboards/vitrine-bases-manuais"
                element={
                  <ProtectedRoute to={"/login"}>
                    <VitrineBasesManuais />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboards/componentes"
                element={
                  <ProtectedRoute to={"/login"}>
                    <Componentes />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboards/onboarding"
                element={
                  <ProtectedRoute to={"/login"}>
                    <Onboarding />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/web-push-registros"
                element={
                  <ProtectedRoute to={"/login"}>
                    <WebPushRegister />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/rotina-exclusao"
                element={
                  <ProtectedRoute to={"/login"}>
                    <WebPushExclusion />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/web-push-agendamentos"
                element={
                  <ProtectedRoute to={"/login"}>
                    <WebPushAgendamentos />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/web-push-agendamentos-2"
                element={
                  <ProtectedRoute to={"/login"}>
                    <WebPushAgendamentos2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin-menu"
                element={
                  <ProtectedRoute to={"/login"}>
                    <AdminMenu />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/home"
                element={
                  //<ProtectedRoute to={"/login"}>
                    <Home />
                  //</ProtectedRoute>
                }
              />
              <Route
                path="/sobre"
                element={
                  //<ProtectedRoute to={"/login"}>
                    <Sobre />
                  //</ProtectedRoute>
                }
              />
              <Route
                path="/equipe"
                element={
                  //<ProtectedRoute to={"/login"}>
                    <Equipe />
                  //</ProtectedRoute>
                }
              />
              <Route
                path="/contato"
                element={
                  //<ProtectedRoute to={"/login"}>
                    <Contato />
                  //</ProtectedRoute>
                }
              />
              <Route
                path="/psicologia-infantil"
                element={
                  //<ProtectedRoute to={"/login"}>
                    <PsicologiaInfantil />
                  //</ProtectedRoute>
                }
              />
              <Route
                path="/pediatra"
                element={
                  //<ProtectedRoute to={"/login"}>
                    <Pediatra />
                  //</ProtectedRoute>
                }
              />
              <Route
                path="/nutricionista"
                element={
                  //<ProtectedRoute to={"/login"}>
                    <Nutricionista />
                  //</ProtectedRoute>
                }
              />
              <Route
                path="/fisioterapia"
                element={
                  //<ProtectedRoute to={"/login"}>
                    <Fisioterapia />
                  //</ProtectedRoute>
                }
              />
              <Route
                path="/avaliacao-neuropsicologica"
                element={
                  //<ProtectedRoute to={"/login"}>
                    <Avaliacaoneuropsicologica />
                  //</ProtectedRoute>
                }
              />
              <Route
                path="/psicopedagogia"
                element={
                  //<ProtectedRoute to={"/login"}>
                    <Psicopedagogia />
                  //</ProtectedRoute>
                }
              />
              <Route
                path="/transtornos-ansiedade-infantil"
                element={
                  //<ProtectedRoute to={"/login"}>
                    <TranstornosAnsiedadeInfantil />
                  //</ProtectedRoute>
                }
              />
              <Route
                path="/transtorno-deficit-atencao-hiperatividade-tdah"
                element={
                  //<ProtectedRoute to={"/login"}>
                    <Tdah />
                  //</ProtectedRoute>
                }
              />
              
              
              <Route path="/login" element={<Login />} />
            </Routes>
          </div>
          <LoginChangePassword
            onRequestClose={handleCloseDialog}
          />
        </div>
        
      </UserStorage>
    </BrowserRouter>
  );
};

export default App;
